import { render } from "./OfferindexComponent.vue?vue&type=template&id=598ff7d4"
import script from "./OfferindexComponent.vue?vue&type=script&lang=js"
export * from "./OfferindexComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__